export const STARTER_AVATARS = [
  { filename: 'potato_avatar_1.svg', label: 'Kawaii Spud' },
  { filename: 'potato_avatar_2.svg', label: 'Fitness Spud' },
  { filename: 'potato_avatar_3.svg', label: 'Office Spud' },
  { filename: 'potato_avatar_4.svg', label: 'Demon Spud' },
  { filename: 'potato_avatar_5.svg', label: 'Lazy Spud' },
  { filename: 'potato_avatar_6.svg', label: 'Fashion Spud' },
  { filename: 'potato_avatar_7.svg', label: 'Chef Spud' },
  { filename: 'potato_avatar_8.svg', label: 'Wizard Spud' },
  { filename: 'potato_avatar_9.svg', label: 'Gamer Spud' },
  { filename: 'potato_avatar_10.svg', label: 'Pirate Spud' },
];

/**
 * Avatars that must be bought in the SpudMarket before they can be worn.
 * Filenames match the `payload` of the corresponding `market_items` row.
 */
export const EXCLUSIVE_AVATARS = [
  { filename: 'potato_avatar_11.svg', label: 'Golden Spud' },
];

/** Default starter avatar filename (stable ID — do not rename files). */
export const DEFAULT_AVATAR_FILENAME = 'potato_avatar_1.svg';
